import React, { Component } from 'react';
import { Divider, HTMLTable, Tag, Button, Intent } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class AdminRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admins: [
        { name: '[GM] Nozich', role: 'Super Admin (Full Access)', ip: '85.102.**.**', status: 'ACTIVE' },
        { name: '[GM] Merlin', role: 'Senior Game Master', ip: '178.240.**.**', status: 'ACTIVE' },
        { name: '[GM] Staff', role: 'Support Moderator', ip: '127.0.0.1', status: 'ACTIVE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Admin Panel User Roles & Access Control
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Manage staff accounts, permission levels, IP whitelists, and Security Audit Access.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Admin Username</th>
              <th style={{ color: '#182026' }}>Assigned Role</th>
              <th style={{ color: '#182026' }}>Whitelisted IP</th>
              <th style={{ color: '#182026' }}>Status</th>
              <th style={{ color: '#182026' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.admins.map((adm, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{adm.name}</td>
                <td className="font-weight-bold" style={{ color: '#106ba3' }}>{adm.role}</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>{adm.ip}</td>
                <td><Tag intent={Intent.SUCCESS} round>{adm.status}</Tag></td>
                <td><Button icon="key" small minimal intent={Intent.WARNING} text="Permissions" /></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
